/**
 * FooterLinks - ANPC dispute resolution links
 */

import { TextLink } from '@/modules/Frontend/UiBlocks'

export function FooterLinks() {
  return (
    <div className="flex flex-col justify-center items-center w-full md:w-auto">
      <p className="text-left text-white font-poppins text-xs xl:text-sm uppercase mb-2">
        Soluționare alternativă a litigiilor
      </p>
      <div className="flex flex-row md:flex-col gap-5 md:gap-3">
        <TextLink
          href="https://anpc.ro/ce-este-sal/"
          title="Solutionarea alternativa a litigiilor"
          external
          variant="light"
          size="sm"
          rel="nofollow noopener noreferrer"
          className="hover:opacity-80 transition-opacity"
        >
          <img
            className="h-[40px]"
            src="/static/frontend/Eadesignro/theme/ro_RO/images/SAL.svg"
            alt="Solutionarea alternativa a litigiilor"
          />
        </TextLink>
        <TextLink
          href="https://reclamatiisal.anpc.ro"
          title="Solutionarea online a litigiilor (SAL)"
          external
          variant="light"
          size="sm"
          rel="nofollow noopener noreferrer"
          className="hover:opacity-80 transition-opacity"
        >
          <img
            className="h-[40px]"
            src="/static/frontend/Eadesignro/theme/ro_RO/images/SOL.svg"
            alt="Solutionarea online a litigiilor (SAL)"
          />
        </TextLink>
      </div>
    </div>
  )
}
